import { render, staticRenderFns } from "./BrandsView.vue?vue&type=template&id=3598308b&"
import script from "./BrandsView.vue?vue&type=script&lang=ts&"
export * from "./BrandsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports